export default {
  language: 'English',
  message: {
    title: "Mixed income housing bonus calculator",
    zoningDistrict: 'Select zoning district',
    affordabilityLevel:'Select an affordability level',
    allThatApply: 'Select all that apply.',
    springGardenS: 'Is the project located south of Spring Garden Street',
    yes: 'Yes',
    no: 'No',
    affordability: {
      lowIncome: 'Low income',
      moderateIncome: 'Moderate income',
    },
    lotAreaSqft: 'Enter lot area in square feet',
    buildingHeight: 'Enter the Building Height',
    totalUnits: 'Proposed number of units in project:',
    unitsEarnedLow: 'Additional Units Earned (Low Income):',
    unitsEarnedMod: 'Additional Units Earned (Moderate Income):',
    greenRoofBonus: 'Number of Green Roof Bonus Units:',
    modIncomePayment: 'Moderate Income Estimated Payment:',
    lowIncomePayment: 'Low Income Estimated Payment:',
    requiredAffordableUnits: 'Required MIHB Affordable Units:',
    requiredMinAffordableUnits: 'Required /MIN Affordable Units:',
    totalRequiredAffordabilityUnits: 'Total Required Affordable Units:',
    additionalFar: 'Additional FAR Earned:',
    totalFar: 'Total FAR:',
    totalFloor: 'Total Floor Area Permitted:',
    overlay: {
      fithDistrict: 'This project is within the Fifth District Overlay District (/VDO).', 
      /*societyHill: "This project is within the Society Hill Area of the Center City Overlay District (/CTR)",*/ 
      greenRoof: 'This project will earn a Green Roof Bonus.', 
      minMixed: 'This project is within the /MIN Mixed Income Neighborhoods Overlay.', 
      todDevelopement: 'This project is within the /TOD Transit Oriented Development Overlay.',
    },
    sFHA: ["Special Flood Hazard Area"],
    numberOfDwellingUnits: 'Number of Dwelling Units Allowed Under Base Zoning:',

    //The About Page Starts Here
    about: 'About',
    aboutTitle: 'About the mixed income housing bonus',
    aboutSubTitle: 'How to use the calculator',
    paragraphOne: 'The mixed income housing bonus is for developers who add affordable dwellings to their projects or pay into a fund that supports affordable housing. In return, the development gets more “by-right” floor area, height, and/or dwelling units. Developers can choose from two bonus levels. The moderate income level is a smaller bonus, but it has less strict affordability standards or a lower payment amount. The low income level is a larger bonus, but it has stricter affordability standards or a higher payment amount.',
    paragraphTwo:{
      text: 'The mixed income housing bonus calculator is used to accurately estimate the:',
      bullets: [
        'Total number of permitted units.',
        'Total number of affordable units that you\'ll be required to provide.',
        'Fee in lieu amount to be paid for a development that uses the mixed income housing bonus.',
      ],
    },
    paragraphThree: {
      text: `To get started, select the property’s base zoning district and enter its lot area. You should also select any applicable overlay districts. You can use`,
      link:{
        text: 'Atlas',
        url: 'https://atlas.phila.gov/',
      },
      continuation: `to find this information.`,
    },
    finalConfirmation: 'This calculator is to be used for conceptual project planning. Where there is a discrepancy between the calculator and the Philadelphia Zoning Code, the Philadelphia Zoning Code shall govern. Final confirmation of units, the required number of affordable units, and/or fee in lieu amount will be made by Philadelphia City Planning Commission staff during zoning permit review.',
    resources: 'Resources',
    code1: {
      link:{
        text: 'Philadelphia Code – 14-702(7) – Mixed Income Housing Bonus',
        url: 'https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117',
      },
    },
    code2: {
      link:{
        text: 'Philadelphia Code – 14-533 – Mixed Income Neighborhood Overlay District',
        url: 'https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906',
      },
    },
    facts: {
      link: {
        text: 'Mixed income housing bonus fact sheets',
        url: 'https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/',
      },
    },
  },
};